import MyClearanceCertificate from './MyClearanceCertificate'

export default MyClearanceCertificate
